export const SEARCH_ENDPOINT = 'search.json';
export const AUTOCOMPLETE_ENDPOINT = 'autocomplete.json';
export const FACETS_ENDPOINT = 'facets.json';
export const ITEM_ENDPOINT = 'item.json';
export const FITMENTS_ENDPOINT = 'ymm/fitments.json';
export const CUSTOMER_VEHICLES_ENDPOINT = 'vehicles/customer.json';
export const COLOR_EXTRACT_ENDPOINT = 'color/extract';
export const TRACK_ENDPOINT = 'track';
